import { Module, ActionContext } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface AtpTrainingStoreState {
  allKeys: any;
}
export default {
  state: {
    allKeys: [],
  },
  mutations: {
    setKeys(state, payload) {
      state.allKeys = payload;
    },
  },
  actions: {
    searchKeys(context: ActionContext<AtpTrainingStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'convert-api-training-keys';
      const body = {
        ATPkeys: payload,
        mode: 'VALIDATE',
      };
      return ApiServiceWrapper.post(endpoint, body);
    },
    markAsUsed(context: ActionContext<AtpTrainingStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'convert-api-training-keys';
      const body = {
        ATPkeys: payload,
        mode: 'CONVERT',
      };
      return ApiServiceWrapper.post(endpoint, body);
    },
  },
  getters: {
    getKeys: state => state.allKeys,
  },
  namespaced: true,
} as Module<AtpTrainingStoreState, RootStoreState>;
